import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue'
import App from './App.vue'
import { filterConfig } from './utils/helper'
import * as SentryHelper from './utils/sentry'
import { store } from './store/store'
import { EventBus } from '@/services/EventBus';
/* eslint-disable no-new,eqeqeq,no-new */

// TODO: this should be the main.js (vue app)

var iApp = null;
function createApp(config, dataset) {
  if (iApp !== null) return
  iApp = new Vue({
    render: h => h('app', { ref: 'app' }, [h(App)]),
    store,
    components: { App },
    data: {
      config: config,
      id: dataset.id
    },
    created() {
      this.$store.commit('changeConfig', this.config);
      this.$store.commit('changeId', this.id);
      this.$store.commit('changeDataset', Object.assign({}, dataset));
    }
  }).$mount('#player');
  if (process.env.VUE_APP_SENTRY_DSN && dataset.debug) {
    SentryHelper.initSentry(process.env, dataset)
  }
}

function initPlayer(dataset) {
  var playerConfig = filterConfig(dataset)
  if (process.env.VUE_APP_SENTRY_DSN && dataset.debug) {
    SentryHelper.loadSentry()
      .then(() => {
        createApp(playerConfig, dataset)
      })
      .catch((error) => {
        console.log('error during initPlayer', error)
        dataset.debug = false;
        createApp(playerConfig, dataset)
      })
  } else {
    createApp(playerConfig, dataset)
  }
}

window.onmessage = function (e) {
  if (e.data.dataset) {
    var dataset = JSON.parse(e.data.dataset);
    initPlayer(dataset);
  }
  if (e.data.$emit) {
    iApp.$refs.app.emit(e.data.$emit, e.data.params)
  }
  if (e.data.get) {
    var ret = iApp.$refs.app.get(e.data.get)
    window.parent.postMessage({
      type: 'get',
      key: e.data.get,
      id: e.data.id,
      value: ret
    }, '*')
  }
}
var id = null
function ready() {
  var query = window.location.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) == 'id') {
      id = decodeURIComponent(pair[1]);
    }
  }
  window.parent.postMessage({
    type: 'ready',
    id: id
  }, '*');
}
ready()

EventBus.$on('heightChange', function (height) {
  window.parent.postMessage({
    type: 'heightChange',
    id: id,
    height: height
  }, '*');
});

EventBus.$on('error', function(error) {
  window.parent.postMessage({
    type: 'error',
    id,
    error
  }, '*')
})

function passToParent(type, data) {
  window.parent.postMessage({
    type: type,
    id: id,
    data: data
  }, '*');
}

EventBus.$on('forceFullscreen', function (needsFullscreen) {
  passToParent('forceFullscreen', needsFullscreen);
});

EventBus.$on('setTitle', function (title) {
  document.title = title;
});

EventBus.$on('externalFullscreen', function(data) {
  // uid:
  // events which have uid are known to have been triggered by the player, and not coming from outside
  // events coming from outside will not be emitted to the parent again
  // This makes sure the event is only triggered once (to prevent event bouncing).
  if (!data?.uid) {
    return;
  }

  passToParent('externalFullscreen', data);
});

[
  'play',
  'pause',
  'seek',
  'stop',
  'playerReady',
  'firstFrame',
  'timeChange',
  'widthChange',
  'complete',
  'theaterMode',
  'set-iframe-class'
].forEach(function (event) {
  EventBus.$on(event, function (data) {
    passToParent(event, data);
  });
});
